import { Product } from "../types";
import { CartItem } from "../store/cartStore";
import apiClient from "./apiClient";

interface CartResponse {
  result: Product[]; // API возвращает Product[]
  total: number;
}

// Функция для преобразования Product[] в CartItem[]
const transformProductsToCartItems = (products: Product[]): CartItem[] => {
  return products.map(product => ({
    ...product,
    // quantity уже приходит с бэкенда для товаров в корзине
    quantity: product.quantity || 1,
    // Теперь бэкенд всегда возвращает stock_quantity из warehouse_stocks
    available_quantity: product.stock_quantity !== undefined 
      ? product.stock_quantity 
      : 0, // Если нет данных о складе, считаем что товара нет
    current_warehouse_id: product.current_warehouse_id,
    is_low_stock: (product.quantity || 1) > (product.stock_quantity || 0),
    current_stock: product.stock_quantity // Для совместимости
  }));
};

// Получение корзины
export const getCart = async (limit: number = 10, offset: number = 0, warehouseId: number = 1): Promise<CartResponse> => {
  try {
    const response = await apiClient.get("/api/cart", {
      params: { limit, offset, warehouse_id: warehouseId },
    });

    return {
      result: response.data.result || [], // Защита от null
      total: response.data.total || 0, // Защита от null
    };
  } catch (error) {
    throw new Error("Ошибка получения корзины");
  }
};

// Добавление в корзину
export const addToCart = async (product_id: number, quantity: number): Promise<void> => {
  try {
    await apiClient.post("/api/cart", { product_id, quantity });
  } catch (error) {
    throw new Error("Ошибка добавления в корзину");
  }
};

// Удаление товара из корзины
export const removeFromCart = async (product_id: number): Promise<void> => {
  try {
    await apiClient.delete("/api/cart", { data: { product_id } });
  } catch (error) {
    throw new Error("Ошибка удаления из корзины");
  }
};

// Очистка всей корзины
export const clearCartOnServer = async (): Promise<void> => {
  try {
    await apiClient.delete("/api/cart", { data: { product_id: null } }); // Передаем JSON с null
  } catch (error) {
    console.error("Ошибка при очистке корзины на сервере:", error);
    throw new Error("Ошибка очистки корзины");
  }
};

// Экспортируем функцию преобразования для использования в компонентах
export { transformProductsToCartItems };
